const Zapisnice = [
  {
    label: "Zápisnica 1",
    semester: "(ZS)",
    data: "./documents/Zapisnice/Zapisnica_1.pdf",
    date: "04.10.2021",
  },
  {
    label: "Zápisnica 2",
    semester: "(ZS)",
    data: "./documents/Zapisnice/Zapisnica_2.pdf",
    date: "11.10.2021",
  },
  {
    label: "Zápisnica 3",
    semester: "(ZS)",
    data: "./documents/Zapisnice/Zapisnica_3.pdf",
    date: "18.10.2021",
  },
  {
    label: "Zápisnica 4",
    semester: "(ZS)",
    data: "./documents/Zapisnice/Zapisnica_4.pdf",
    date: "25.10.2021",
  },
  {
    label: "Zápisnica 5",
    semester: "(ZS)",
    data: "./documents/Zapisnice/Zapisnica_5.pdf",
    date: "01.11.2021",
  },
  {
    label: "Zápisnica 6",
    semester: "(ZS)",
    data: "./documents/Zapisnice/Zapisnica_6.pdf",
    date: "08.11.2021",
  },
  {
    label: "Zápisnica 7",
    semester: "(ZS)",
    data: "./documents/Zapisnice/Zapisnica_7.pdf",
    date: "15.11.2021",
  },
  {
    label: "Zápisnica 8",
    semester: "(ZS)",
    data: "./documents/Zapisnice/Zapisnica_8.pdf",
    date: "22.11.2021",
  },
  {
    label: "Zápisnica 9",
    semester: "(ZS)",
    data: "./documents/Zapisnice/Zapisnica_9.pdf",
    date: "29.11.2021",
  },
  {
    label: "Zápisnica 10",
    semester: "(ZS)",
    data: "./documents/Zapisnice/Zapisnica_10.pdf",
    date: "06.12.2021",
  },
  {
    label: "Zápisnica 11",
    semester: "(ZS)",
    data: "./documents/Zapisnice/Zapisnica_11.pdf",
    date: "13.12.2021",
  },
  {
    label: "Zápisnica 12",
    semester: "(LS)",
    data: "./documents/Zapisnice/Zapisnica_12.pdf",
    date: "14.02.2022",
  },
  {
    label: "Zápisnica 13",
    semester: "(LS)",
    data: "./documents/Zapisnice/Zapisnica_13.pdf",
    date: "21.02.2022",
  },
  {
    label: "Zápisnica 14",
    semester: "(LS)",
    data: "./documents/Zapisnice/Zapisnica_14.pdf",
    date: "28.02.2022",
  },
  {
    label: "Zápisnica 15",
    semester: "(LS)",
    data: "./documents/Zapisnice/Zapisnica_15.pdf",
    date: "07.03.2022",
  },
  {
    label: "Zápisnica 16",
    semester: "(LS)",
    data: "./documents/Zapisnice/Zapisnica_16.pdf",
    date: "14.03.2022",
  },
  {
    label: "Zápisnica 17",
    semester: "(LS)",
    data: "./documents/Zapisnice/Zapisnica_17.pdf",
    date: "28.03.2022",
  },
  {
    label: "Zápisnica 18",
    semester: "(LS)",
    data: "./documents/Zapisnice/Zapisnica_18.pdf",
    date: "04.04.2022",
  },
  {
    label: "Zápisnica 19",
    semester: "(LS)",
    data: "./documents/Zapisnice/Zapisnica_19.pdf",
    date: "11.04.2022",
  },
  {
    label: "Zápisnica 20",
    semester: "(LS)",
    data: "./documents/Zapisnice/Zapisnica_20.pdf",
    date: "25.04.2022",
  },
  {
    label: "Zápisnica 21",
    semester: "(LS)",
    data: "./documents/Zapisnice/Zapisnica_21.pdf",
    date: "02.05.2022",
  },
  {
    label: "Zápisnica 22",
    semester: "(LS)",
    data: "./documents/Zapisnice/Zapisnica_22.pdf",
    date: "09.05.2022",
  }
]

export default Zapisnice;
